import * as SwitchPrimitive from '@radix-ui/react-switch'
import type { ComponentProps, ReactNode } from 'react'
import { cn } from '@/lib/cn'

export type SwitchProps = ComponentProps<typeof SwitchPrimitive.Root>

/**
 * 30x17 track, 13px thumb. The 1px border plus 1px padding leave exactly 13px
 * of travel, which is why the thumb translation is hard-coded rather than
 * expressed as a percentage.
 */
export function Switch({ className, ...props }: SwitchProps): ReactNode {
  return (
    <SwitchPrimitive.Root
      className={cn(
        'inline-flex h-[17px] w-[30px] shrink-0 items-center rounded-full border border-border bg-surface p-px transition-colors',
        'data-[state=checked]:border-accent data-[state=checked]:bg-accent',
        'disabled:pointer-events-none disabled:opacity-45',
        className,
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb className="pointer-events-none block size-[13px] rounded-full bg-fg-faint transition-transform data-[state=checked]:translate-x-[13px] data-[state=checked]:bg-surface-raised" />
    </SwitchPrimitive.Root>
  )
}
